import config from '@/config'
import axios from 'axios'
import { authHeader } from '@/helpers'


const { API_URL } = config

const AdminURL = `${API_URL}/api/admin`

export const productService = {
  getProducts,
  createProduct,
  deleteProduct,
  editProduct,
  getAvailProducts
}

async function editProduct(productData) {
  let opts = {
    url: `${API_URL}/api/admin/products/edit`,
    headers: authHeader(),
    method: 'POST',
    data: productData
  }
  let res = await axios(opts)
  let { product } = res.data
  // console.log(`editProduct response: `, res.data)
  console.log(`edited product ${product.productId}!`)
  return product
}

function getProducts() {
  let opts = {
    url: `${API_URL}/api/admin/products`,
    headers: authHeader()
  }
  return new Promise((resolve, reject) => {
    axios(opts)
      .then((res) => {
        let { data } = res
        if (!data) reject(new Error('no data on response'))
        resolve(data)

      })
      .catch(reject)
  })
}

function getAvailProducts() {
  let opts = {
    url: `${API_URL}/api/products`,
    headers: authHeader()
  }
  return new Promise((resolve, reject) => {
    axios(opts)
      .then((res) => {
        let { data } = res
        if (!data) reject(new Error('no data on response'))
        resolve(data)

      })
      .catch(reject)
  })
}

function createProduct(productData) {
  let opts = {
    url: `${API_URL}/api/admin/products/create`,
    data: productData,
    method: 'POST',
    headers: authHeader()
  }
  return new Promise((resolve, reject) => {
    axios(opts)
      .then(res => {
        let { data } = res
        if (!data.success) {
          reject(new Error(data.error))
        } else {
          resolve(data.product)
        }
      })
      .catch(reject)
  })
}

async function deleteProduct(productId) {
  let url = `${AdminURL}/products/id/${productId}`
  let opts = { url, headers: authHeader(), method: 'delete' }
  try {
    let res = await axios(opts)
    return res
  } catch (e) {
    console.error(e)
  }
}